import { useEffect, useRef, useState } from "react";

import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import { finishSsoLink } from "@/api/sso";

const MESSAGES: Record<string, string> = {
  already_linked: "Ce compte est déjà associé à votre profil.",
  subject_already_linked: "Cette identité est déjà associée à un autre compte Cortex.",
  email_belongs_to_another_account:
    "Cette adresse appartient à un autre compte Cortex. Associez l'identité correspondant à votre propre adresse.",
  domain_not_allowed: "Le domaine de cette adresse n'est pas autorisé par votre organisation.",
  email_not_verified: "Le fournisseur d'identité n'a pas vérifié cette adresse.",
  invalid_or_expired_state: "La demande a expiré. Recommencez depuis votre profil.",
  state_is_for_login: "Ce lien correspond à une connexion, pas à une association.",
};

export function SsoLinkCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [linked, setLinked] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const code = params.get("code");
    const state = params.get("state");
    if (params.get("error") || !code || !state) {
      setError("Association annulée ou réponse incomplète.");
      return;
    }
    finishSsoLink(state, code)
      .then((res) => setLinked(res.linked_email))
      .catch((e) => {
        const detail = (e as { response?: { data?: { detail?: unknown } } }).response?.data
          ?.detail;
        const key = typeof detail === "string" ? detail : "";
        setError(MESSAGES[key] ?? "L'association a échoué.");
      });
  }, [params]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8, px: 2 }}>
      <Stack spacing={3} alignItems="center" sx={{ maxWidth: 480, width: "100%" }}>
        {error === null && linked === null && (
          <>
            <CircularProgress />
            <Typography variant="body2" color="text.secondary">
              Association en cours…
            </Typography>
          </>
        )}
        {linked !== null && (
          <Alert severity="success" sx={{ width: "100%" }}>
            {linked} est désormais associée à votre compte. Vous pourrez vous connecter avec
            cette identité dès votre prochaine visite.
          </Alert>
        )}
        {error !== null && (
          <Alert severity="error" sx={{ width: "100%" }}>
            {error}
          </Alert>
        )}
        {(linked !== null || error !== null) && (
          <Button variant="contained" onClick={() => navigate("/profile", { replace: true })}>
            Retour au profil
          </Button>
        )}
      </Stack>
    </Box>
  );
}
